import { css } from 'styled-components';

export default css`
  .redirect-login-page {
    text-align: center;
    width: 100%;
    height: 100%;
    margin-top: 158px;
    .header {
      color: #485465;
      font-size: 48px;
      line-height: inherit;
    }
    .message {
      margin-top: 84px;
      color: #707070;
      font-size: 24px;
    }
  }
`;
